import { State } from "./State";

export class InsuranceAddress {
  firstName = "";
  lastName = "";
  address = "";
  apt = "";
  city = "";
  state = new State();
  zip = "";
  formatted = "";
  streetNumber = "";
}
